const WHATSAPP_NUMBER = '56993396909';
const WHATSAPP_BASE_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

export const generateWhatsAppLink = (productName, price) => {
    const message = encodeURIComponent(
        `¡Hola! 🎂 Me interesa pedir un(a) ${productName} ($${price}). ¿Está disponible? 💕`
    );
    return `${WHATSAPP_BASE_URL}?text=${message}`;
};

export const WHATSAPP_GENERAL_LINK = `${WHATSAPP_BASE_URL}?text=${encodeURIComponent(
    '¡Hola! 🎂 Me gustaría hacer un pedido. ¿Podrían ayudarme? 💕'
)}`;

export const SOCIAL_LINKS = {
    instagram: 'https://www.instagram.com/reposteria.dulce.mora?igsh=Y2R1cndxYm4wNmxh',
    facebook: 'https://www.facebook.com/',
    tiktok: 'https://www.tiktok.com/',
    whatsapp: WHATSAPP_GENERAL_LINK,
};

export const products = [
    {
        id: 1,
        name: 'Cheesecake de Frambuesa',
        price: '16.990',
        description: 'Irresistible, cremoso y natural. Frescura que enamora.',
        longDescription: 'Nuestro cheesecake de frambuesa es una obra maestra de sabor natural y textura cremosa. Elaborado con frambuesas frescas naturales, sin saborizantes artificiales, cada bocado es una explosión de frescura que enamora.',
        features: ['Frambuesas naturales', 'Cremoso y suave', 'Sin saborizantes artificiales', '28 centímetros de diámetro'],
        category: 'cheesecake',
        image: '/images/cheesecake-frambuesa.jpg',
        bgGradient: 'from-pink-50 to-rose-50',
        accentColor: 'text-rose-600',
        badgeColor: 'bg-rose-600',
        borderColor: 'border-rose-200',
    },
    {
        id: 2,
        name: 'Kuchen de Nuez',
        price: '14.990',
        description: 'Irresistible, crujiente y natural. Tradición que enamora, 28 centimatros de diametro.',
        longDescription: 'El kuchen de nuez es un clásico de la tradición sureña chilena. Elaborado con nueces cuidadosamente seleccionadas e ingredientes naturales, ofrece una textura crujiente irresistible.',
        features: ['Nueces seleccionadas', 'Ingredientes naturales', 'Textura crujiente', '28 centímetros de diámetro'],
        category: 'kuchen',
        image: '/images/kuchen-nuez.jpg',
        bgGradient: 'from-amber-50 to-orange-50',
        accentColor: 'text-amber-800',
        badgeColor: 'bg-amber-800',
        borderColor: 'border-amber-200',
    },
    {
        id: 3,
        name: 'Kuchen Sureño de Frambuesa',
        price: '14.990',
        description: 'Suave, frutal y con el crujiente perfecto. Tradición que enamora.',
        longDescription: 'Nuestro kuchen sureño de frambuesa combina lo mejor de la tradición chilena del sur. Frambuesas naturales y jugosas bajo una cubierta crujiente de streusel dorado.',
        features: ['Frambuesas naturales y jugosas', 'Cubierta crujiente de streusel', 'Ingredientes seleccionados', '28 centímetros de diámetro'],
        category: 'kuchen',
        image: '/images/kuchen-frambuesa.jpg',
        bgGradient: 'from-red-50 to-pink-50',
        accentColor: 'text-red-800',
        badgeColor: 'bg-red-800',
        borderColor: 'border-red-200',
    },
    {
        id: 4,
        name: 'Pie de Limón',
        price: '11.990',
        description: 'Fresca, cremosa y deliciosa. Sabor cítrico y refrescante.',
        longDescription: 'Nuestro pie de limón es una delicia refrescante con un sabor cítrico perfecto. Coronado con un merengue suave y ligero, dorado a la perfección, sobre una base de masa crocante.',
        features: ['Sabor cítrico y refrescante', 'Merengue suave y ligero', 'Ingredientes seleccionados', '28 centímetros de diámetro'],
        category: 'pie',
        image: '/images/pie-limon.jpg',
        bgGradient: 'from-yellow-50 to-green-50',
        accentColor: 'text-green-700',
        badgeColor: 'bg-green-700',
        borderColor: 'border-green-200',
    },
    {
        id: 5,
        name: 'Cheesecake de Frutilla',
        price: '16.990',
        description: 'Fresco, cremoso e irresistible. Con frutillas naturales.',
        longDescription: 'Una explosión de sabor con frutillas naturales que se derrite en tu boca. Nuestro cheesecake de frutilla es la combinación perfecta de textura cremosa y sabor irresistible.',
        features: ['Sabor irresistible con frutillas', 'Textura cremosa', 'Ingredientes de calidad', '28 centímetros de diámetro'],
        category: 'cheesecake',
        image: '/images/cheesecake-frutilla.jpg',
        bgGradient: 'from-red-50 to-rose-50',
        accentColor: 'text-red-600',
        badgeColor: 'bg-red-600',
        borderColor: 'border-red-200',
    },
    {
        id: 6,
        name: 'Waffles Irresistibles',
        price: '9.990',
        description: 'Suaves, esponjosos e irresistibles. Para cualquier momento del día.',
        longDescription: 'Waffles con la textura perfecta: suaves por dentro, crujientes por fuera. Ideales para combinar con frutas, chocolate, dulce de leche y más.',
        features: ['Textura perfecta', 'Ingredientes premium', 'Ideales para combinar', 'Hechos con amor'],
        category: 'otros',
        image: '/images/waffles.jpg',
        bgGradient: 'from-amber-50 to-yellow-50',
        accentColor: 'text-amber-900',
        badgeColor: 'bg-amber-900',
        borderColor: 'border-amber-200',
    },
    {
        id: 7,
        name: 'Cheesecake de Maracuyá',
        price: '16.990',
        description: 'Fresca, cremosa e irresistible. Sabor tropical con maracuyá natural.',
        longDescription: 'Un viaje tropical en cada bocado. Nuestro cheesecake de maracuyá combina la frescura y acidez del maracuyá natural con una base cremosa irresistible.',
        features: ['Sabor tropical natural', 'Textura cremosa', 'Ingredientes de calidad', '28 centímetros de diámetro'],
        category: 'cheesecake',
        image: '/images/cheesecake-maracuya.jpg',
        bgGradient: 'from-yellow-50 to-amber-50',
        accentColor: 'text-amber-600',
        badgeColor: 'bg-amber-600',
        borderColor: 'border-yellow-200',
    },
    {
        id: 8,
        name: 'Arroz con Leche Tradicional',
        price: '4.990',
        description: 'Cremoso, suave y preparado con ingredientes naturales. El sabor de casa en cada cucharada.',
        longDescription: 'Disfruta de un delicioso arroz con leche elaborado artesanalmente con leche fresca, arroz de calidad, canela y un delicado toque de vainilla. Una receta tradicional que conserva el auténtico sabor casero, perfecta para compartir o darte un gusto en cualquier momento.',
        features: [
            'Receta tradicional',
            'Ingredientes naturales',
            'Textura extra cremosa',
            'Porción para 4 personas'
        ],
        category: 'otros',
        image: '/images/arroz-con-leche.jpg',
        bgGradient: 'from-rose-50 to-pink-100',
        accentColor: 'text-pink-600',
        badgeColor: 'bg-pink-500',
        borderColor: 'border-rose-200',
    },
    {
        id: 9,
        name: 'Leche Asada',
        price: '11.990',
        description: 'Irresistible, cremosa y casera. El sabor de la tradición que enamora.',
        longDescription: 'Nuestra leche asada es preparada con una receta tradicional, utilizando ingredientes seleccionados para lograr una textura suave, cremosa y un delicioso caramelo dorado. Un postre casero que combina el auténtico sabor de la tradición con ese toque especial hecho con amor.',
        features: [
            'Ingredientes seleccionados',
            'Receta tradicional',
            'Textura cremosa',
            'Porción para 10 personas'
        ],
        category: 'otros',
        image: '/images/leche-asada.jpg',
        bgGradient: 'from-stone-50 to-amber-50',
        accentColor: 'text-stone-600',
        badgeColor: 'bg-stone-600',
        borderColor: 'border-amber-200',
    },
];


// ==================== PROMOCIONES ====================
export const promotions = [
    {
        id: 1,
        title: 'Waffles',
        subtitle: 'Irresistibles',
        tagline: '2x1 en Waffles',
        description: 'Compra tu porción de waffles (2 discos) y llévate 1 porción más ¡GRATIS! (2 discos más)',
        shortDescription: 'Compra 1 porción y llévate otra GRATIS',
        badge: '¡PROMO!',
        price: '9.990',
        originalPrice: '19.980',
        discount: '50%',
        image: '/images/waffles.jpg',
        productImage: '/images/waffles.jpg',
        features: [
            { icon: '🧇', title: 'Textura perfecta', desc: 'Suaves y esponjosos' },
            { icon: '🍓', title: 'Ingredientes de calidad', desc: 'Selección premium' },
            { icon: '🍫', title: 'Ideales para combinar', desc: 'Con frutas, chocolate y más' },
            { icon: '💕', title: 'Hechos con amor', desc: 'Como en casa' },
        ],
        promoDetails: {
            buy: { title: 'TÚ COMPRAS', description: '1 PORCIÓN', subtitle: '(2 discos)' },
            gift: { title: 'TE REGALAMOS', description: '1 PORCIÓN MÁS', subtitle: '(2 discos más)' },
        },
        colorTheme: 'brown',
        bgGradient: 'from-amber-50 via-orange-50 to-yellow-50',
        accentColor: 'text-amber-900',
        badgeColor: 'bg-amber-900',
        borderColor: 'border-amber-300',
        validUntil: '31 de Diciembre',
        tag: 'OFERTA LIMITADA',
    },
    // Puedes agregar más promociones aquí en el futuro
];

export const generatePromoWhatsAppLink = (promoTitle) => {
    const message = encodeURIComponent(
        `¡Hola! 🎂 Vi la promoción "${promoTitle}" en su página y me interesa. ¿Podrían darme más información? 💕`
    );
    return `${WHATSAPP_BASE_URL}?text=${message}`;
};


export const categories = [
    { id: 'all', name: 'Todos', icon: '🎂' },
    { id: 'cheesecake', name: 'Cheesecakes', icon: '🍰' },
    { id: 'kuchen', name: 'Kuchen', icon: '🥧' },
    { id: 'pie', name: 'Pies', icon: '🍋' },
    { id: 'otros', name: 'Otros', icon: '🧇' },
];

export const testimonials = [
    {
        id: 1,
        name: 'María González',
        text: '¡El cheesecake de frambuesa es simplemente divino! Se nota que está hecho con mucho amor y los mejores ingredientes. 💕',
        rating: 5,
        avatar: '👩',
    },
    {
        id: 2,
        name: 'Carlos Muñoz',
        text: 'Pedí el kuchen de nuez para un cumpleaños y fue un éxito total. Crujiente, sabroso y con ese toque casero.',
        rating: 5,
        avatar: '👨',
    },
    {
        id: 3,
        name: 'Ana Pérez',
        text: 'Los waffles son increíbles. Y el pie de limón... ¡una delicia! El servicio por WhatsApp es súper rápido.',
        rating: 5,
        avatar: '👩‍🦱',
    },
    {
        id: 4,
        name: 'Valentina Torres',
        text: 'El cheesecake de maracuyá es lo mejor que he probado. Fresco, cremoso y con un sabor tropical increíble. 🌟',
        rating: 5,
        avatar: '👧',
    },
];